import { Component } from '@angular/core';

@Component({
    selector: 'app-unauthorized-page',
    templateUrl: './unauthorized-page.component.html',
})
export class UnauthorizedPageComponent {}
